// extracted by mini-css-extract-plugin
module.exports = {"overlayBottomCenter":"voting-countdown_overlayBottomCenter__iKKLq","countdown":"voting-countdown_countdown__iq0CO"};